export const heroText = {
  en: {
    title: {
      line1: "Satisfying your Vietnamese cravings ",
      highlight: "Since 2005",
    },

    intro: "Hello, I’m Tiffany Bui — Guiding You Toward Your Best-Fit Career",
  },

  vi: {
    title: {
      line1: "Tìm Đúng Con Đường.",
      line2: "Vững Bước Tương Lai",
    },
    description: `Tôi đồng hành cùng bạn tìm ra con đường nghề nghiệp 
phù hợp với chính bạn — dựa trên giá trị sống, 
tính cách và bản sắc văn hoá.`,
    intro:
      "Xin chào, tôi là Tiffany Bùi — Người đồng hành định hướng sự nghiệp",
  },
};
